import {ThemePalette} from '@angular/material/core';

export class OptionalTableColumn{
  name: string;
  displayName: string;
  selected?: boolean;
  color?: ThemePalette;

  constructor(name: string, displayName: string) {
    this.name = name;
    this.displayName = displayName;
    this.color = 'primary';
    this.selected = false;
  }
}
